// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const ReactDOM = require('react-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { HireCreditLimit } = require('components/hire/hireCreditLimit/hireCreditLimit');
const { HirePaymentMethod } = require('components/hire/hirePaymentMethod/hirePaymentMethod');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    SECOND_STEP,
    WIZARD_SECOND_STEP,
} = require('constants/index');
const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');
const { PROC_CARD_VIRTUAL_CREDIT } = require('utilities/tagging');

class HireCardVirtualCreditStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.setNode = this.setNode.bind(this);
        this.onCreditLimitModalContinue = this.onCreditLimitModalContinue.bind(this);
    }

    componentDidMount() {
        this.handleCMSLinks();
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    componentWillUnmount() {
        this.handleCMSLinks(true);
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    handleCMSLinks(removeOnly = false) {
        const element = ReactDOM.findDOMNode(this.nodeReference);
        if (!!element) {
            const anchors = element.getElementsByTagName('a');
            Array.from(anchors).forEach(anchorElement => {
                anchorElement.removeEventListener('click', () => {});
                if (!removeOnly) {
                    anchorElement.addEventListener('click', () => {
                        recordLink(PROC_CARD_VIRTUAL_CREDIT, anchorElement.text);
                    });
                }
            });
        }
    }

    onCreditLimitModalContinue() {
        const {
            immHireCreditLimit,
            setHireCreditLimit,
            toggleCreditLimitModal,
            validate,
        } = this.props;
        setHireCreditLimit(immHireCreditLimit.get('creditLimitModalValue'), true);
        toggleCreditLimitModal(false);
        validate(WIZARD_SECOND_STEP, true);
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];
        const accountsIndexes = immAccounts.get('byOrder').filter( accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter( accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter( accountId =>
            // We remove the accounts where the user doesn't have one of the required intervention types.
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            handleAccountChange,
            immAccounts,
            immGlobalVariables,
            immHireCardNameSelector,
            immHireCardVirtualCredit,
            immHireCreditLimit,
            immHirePaymentMethod,
            isInactiveAccountsEnabled,
            newCardsFF
        } = this.props;
        const immStep2 = immHireCardVirtualCredit.getIn(['steps', SECOND_STEP]);
        const accountErrorMsgVisible = immStep2.get('accountIsDirty') && !immStep2.get('accountIsValid');
        const accountErrorMsg = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step2SelectAccountError');
        const accountLabel = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step2SelectAccount');
        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-visaOpenLinkUrl');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        return (
            <article className="hire-card-virtual-credit-step-two">
                <FormattedText
                    className="hire-card-virtual-credit__step-title"
                    value="hireCardVirtualCredit-hireCardVirtualCredit_step2Title"
                />
                <HireCardNameSelector
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    currentAccountId={immStep2.get('accountId')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    showAvailableBalance={true}
                    loading={isBlockedAccountsLoading}
                />
                <h4 className="hire-card-virtual-credit__section-header">
                    <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step2CardData" />
                </h4>
                <HireCreditLimit
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    productSubType="803"
                    productType="500"
                    referenceStandard="0000001"
                    handleModalContinue={this.onCreditLimitModalContinue}
                    newSetCardLimit={newCardsFF ? true : false}
                />
                <HirePaymentMethod
                    immCreditLimit={immHireCreditLimit}
                    immGlobalVariables={immGlobalVariables}
                    immHirePaymentMethod={immHirePaymentMethod}
                    newSetCardLimit={newCardsFF ? true : false}
                />
                <OKMessage type="informative" ref={this.setNode}>
                    <FormattedText value="disclaimerPersonalInfo-disclaimerPersonalInfo_virtualCreditMsg" />
                    &nbsp;
                    <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                        <FormattedText value="disclaimerPersonalInfo-disclaimerPersonalInfo_virtualCreditLinkText" />
                    </OKLink>
                </OKMessage>
            </article>
        );
    }
}

HireCardVirtualCreditStep2.propTypes = {
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardVirtualCredit: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
};

module.exports = HireCardVirtualCreditStep2;

